import React from "react";
import { Provider } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import store from "../store";
import { AdminPage, ConventionPage, LoginPage } from "../pages";
import { BRAND, ROUTES } from "../utils/constants";

const BRAND_ROUTES = Object.freeze({
  [BRAND.FUNKO]: [
    {
      element: <ConventionPage brand={BRAND.FUNKO} />,
      path: ROUTES.HOME,
    },
    {
      element: <AdminPage brand={BRAND.FUNKO} />,
      path: ROUTES.ADMIN,
    },
    {
      element: <ConventionPage brand={BRAND.FUNKO} isPreview={true} />,
      path: ROUTES.PREVIEW,
    },
  ],
  [BRAND.LOUNGEFLY]: [
    {
      element: <ConventionPage brand={BRAND.LOUNGEFLY} />,
      path: ROUTES.HOME,
    },
    {
      element: <AdminPage brand={BRAND.LOUNGEFLY} />,
      path: ROUTES.ADMIN,
    },
    {
      element: <ConventionPage brand={BRAND.LOUNGEFLY} isPreview={true} />,
      path: ROUTES.PREVIEW,
    },
  ],
  [BRAND.MONDO]: [
    {
      element: <ConventionPage brand={BRAND.MONDO} />,
      path: ROUTES.HOME,
    },
    {
      element: <AdminPage brand={BRAND.MONDO} />,
      path: ROUTES.ADMIN,
    },
    {
      element: <ConventionPage brand={BRAND.MONDO} isPreview={true} />,
      path: ROUTES.PREVIEW,
    },
  ],
});

/**
 * @desc Main entry point for app.
 */
const App = () => {
  // CONSTANTS ----------------------------------------------------------------

  const brand = process.env.REACT_APP_BRAND;

  // DYNAMIC CONSTANTS --------------------------------------------------------

  let routes = [
    {
      element: <LoginPage />,
      path: ROUTES.LOGIN,
    },
  ];
  switch (brand) {
    case "funko":
      routes = routes.concat(BRAND_ROUTES[BRAND.FUNKO]);
      break;
    case "lf":
      routes = routes.concat(BRAND_ROUTES[BRAND.LOUNGEFLY]);
      break;
    case "mondo":
      routes = routes.concat(BRAND_ROUTES[BRAND.MONDO]);
      break;
    default:
      break;
  }
  const router = createBrowserRouter(routes);

  // COMPONENT ----------------------------------------------------------------

  return (
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  );
};

export default App;
